module.exports = __webpack_public_path__ + "media/images/smart_phone/toplogo_10-830f432e46001afae2ccb54f7347346c.png";